import { render } from "./index.vue?vue&type=template&id=2c2a8178&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2c2a8178&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2c2a8178&lang=scss"

import exportComponent from "F:\\工作\\project\\kaola\\kaola-project-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2a8178"]])

export default __exports__